













import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { isPassword } from '@/utils/validate'
import { updatePassword } from '@/api/users'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'PasswordModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  private visible = false
  private formParams = {
    password: ''
  }

  // 密码校验
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (!isPassword(value)) {
      callback(new Error('8~16位数字和英文组成'))
    } else {
      callback()
    }
  }

  private rules = {
    password: [{ validator: this.validatePassword, trigger: 'change' }]
  }

  private close() {
    this.$emit('update:operationDialogFlag', false);
    (this.$refs.form as ElForm).resetFields()
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        await updatePassword(this.formParams)
        this.close()
        await UserModule.LogOut()
        this.$alert('密码修改成功，请重新登录', '提示', {
          confirmButtonText: '去登录',
          showClose: false,
          type: 'success',
          callback: async() => {
            this.$router.push(`/login?redirect=${this.$route.fullPath}`)
          }
        })
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
  }
}
